import { ReactElement } from 'react';
import { Text } from '@chakra-ui/react';

import { PropsWithChildren } from 'lib/@types';

const CardBody = ({ children }: PropsWithChildren): ReactElement => (
  <Text
    fontSize='14px'
    fontWeight='500'
    lineHeight='26px'
    color='text.100'
    data-testid='card-body'
    textAlign='left'
  >
    {children}
  </Text>
);

export default CardBody;
